/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { DemandeRDVRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { DemandeRDVResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * DemandeRDVApi - axios parameter creator
 * @export
 */
export const DemandeRDVApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the RDV detail.
         * @summary Get the RDV detail
         * @param {string} storeId The store identifier.
         * @param {DemandeRDVRequest} demandeRDVRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demandeRDV: async (storeId: string, demandeRDVRequest: DemandeRDVRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('demandeRDV', 'storeId', storeId)
            // verify required parameter 'demandeRDVRequest' is not null or undefined
            assertParamExists('demandeRDV', 'demandeRDVRequest', demandeRDVRequest)
            const localVarPath = `/store/{storeId}/rdvservice/submitForm`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(demandeRDVRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DemandeRDVApi - functional programming interface
 * @export
 */
export const DemandeRDVApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DemandeRDVApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the RDV detail.
         * @summary Get the RDV detail
         * @param {string} storeId The store identifier.
         * @param {DemandeRDVRequest} demandeRDVRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async demandeRDV(storeId: string, demandeRDVRequest: DemandeRDVRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemandeRDVResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.demandeRDV(storeId, demandeRDVRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DemandeRDVApi - factory interface
 * @export
 */
export const DemandeRDVApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DemandeRDVApiFp(configuration)
    return {
        /**
         * Get the RDV detail.
         * @summary Get the RDV detail
         * @param {string} storeId The store identifier.
         * @param {DemandeRDVRequest} demandeRDVRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demandeRDV(storeId: string, demandeRDVRequest: DemandeRDVRequest, options?: any): AxiosPromise<DemandeRDVResponse> {
            return localVarFp.demandeRDV(storeId, demandeRDVRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DemandeRDVApi - object-oriented interface
 * @export
 * @class DemandeRDVApi
 * @extends {BaseAPI}
 */
export class DemandeRDVApi extends BaseAPI {
    /**
     * Get the RDV detail.
     * @summary Get the RDV detail
     * @param {string} storeId The store identifier.
     * @param {DemandeRDVRequest} demandeRDVRequest The request object for project creation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandeRDVApi
     */
    public demandeRDV(storeId: string, demandeRDVRequest: DemandeRDVRequest, options?: any) {
        return DemandeRDVApiFp(this.configuration).demandeRDV(storeId, demandeRDVRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
